const defaultTheme = {
  thIntro: 'mt-20',
};

export const themes = {
  default: defaultTheme,
  thumbnail: defaultTheme,
};
